import React from 'react';
import PropTypes from 'prop-types';
import { RichText } from '../Common/TextEditor/TextEditor';
import { MetadocumentApiClient } from './api/api-client.js';
// import Popover from 'react-popover';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import { IconButton } from '@projeccions-pdc/react-icon';
import DateTimePicker from '../Common/DateTimePicker';
import moment from 'moment';
import Dropzone from 'react-dropzone';
import Loader from '../Common/Loader';
import { getIconForFileExtension } from '../Search/FileHelper';
import LocalizedStrings from '../Localization/localization';
import AppContext from '../../AppContext';
import './css/meetings-notes.css';

class MeetingNotes extends React.Component {
    static propTypes = {
        //Used but not recognized by linter
        groupId: PropTypes.string,
        contentId: PropTypes.string,
        openFile: PropTypes.func.isRequired,
        children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
        openContent: PropTypes.func,
        fullScreen: PropTypes.any.isRequired,
        disabled: PropTypes.bool,
    };

    constructor(props) {
        super(props);
        this.state = {
            notes: undefined,
            attachments: {}, //[{ name: 'nota de voz', icon: 'fa-file-audio-o' }, { name: 'moleskine-notes', icon: 'fa-file' }, { name: 'store check', icon: 'fa-image' }, { name: 'Formulario visita', icon: 'fa-table' }],
            isMeetingsOpen: false,
            uploadingFiles: false,
            deleteConfirmationPending: false
        };
        this.initializeApiClient(this.props);
    }

    initializeApiClient = props => {

        this.metadocumentApiClient = new MetadocumentApiClient(
            props.contentId,
            props.groupId
        );

        let appContext = new AppContext();
        let language = appContext.getLanguage();

        this.metadocumentApiClient.setCurrentLanguage(language);
        this.metadocumentApiClient.setReadOnlyMode(false);

        // this.loadNotesAndAttachments();
    };

    loadNotesAndAttachments = () => {
        // Load Notes
        // this.metadocumentApiClient
        //     .load()
        //     .then(() => {
        return this.metadocumentApiClient
            .fetchNotesAndAttachments()
            .then(response => {
                let notes = response.notes;
                let attachments = response.files ? response.files : {};
                this.setState({ notes, attachments, mtgDate: moment(this.metadocumentApiClient.getMeetingDate()) });
            }).catch(err => console.log('Notes err', err.message));
        // }).catch(err => console.log('M err', err.message));
    };

    componentDidUpdate(prevProps, prevState) {
        if (this.props.contentId !== prevProps.contentId) {
            this.initializeApiClient(this.props);
            // this.loadNotesAndAttachments();
        }
        if (this.state.isMeetingsOpen !== prevState.isMeetingsOpen && this.state.isMeetingsOpen === true) {
            this.loadNotesAndAttachments();
        }
    }

    handleEditorChange = (slot, content) => {
        this.metadocumentApiClient.setNotes(content).then(() => this.setState({ content }));
    };

    handleDateChange = newDate => {
        this.setState({ mtgDate: newDate });
        let newContent = Object.assign({}, this.metadocumentApiClient.getData());
        newContent.date = newDate.toDate().toISOString();

        this.metadocumentApiClient.setContentDefinition(newContent).then(() => this.setState({ mtgDate: newDate }));
    };

    handleDeleteAttachment = (evt, key) => {
        evt.stopPropagation();
        this.setState({ deleteConfirmationPending: true, pendingDeleteId: key });
    };

    handleAgreeConfirmation = async evt => {
        evt.stopPropagation();
        let content = await this.metadocumentApiClient.deleteAttachment(this.state.pendingDeleteId);
        let notes = content.notes;
        let attachments = content.files ? content.files : {};
        this.setState({ notes, attachments, pendingDeleteId: undefined, deleteConfirmationPending: false });
        //console.log('handleDeleteAttachment', response);
    };

    handleDisagreeConfirmation = evt => {
        evt.stopPropagation();
        this.setState({ deleteConfirmationPending: false });
    };

    handleOpenAttachment = (fileId, fileName) => {
        // console.log('do something!', fileId, fileName);
        let fileType = '';
        let aux = fileName.split('.');
        let extension = aux[aux.length - 1];
        if (
            ['3G2', '3GP', 'ASF', 'AVI', 'FLV', 'M4V', 'MOV', 'MP4', 'MPG', 'RM', 'SRT', 'SWF', 'VOB', 'WMV'].indexOf(
                extension.toUpperCase()
            ) > -1
        ) {
            fileType = 'video';
        } else if (
            ['BMP', 'DDS', 'GIF', 'JPG', 'PNG', 'PSD', 'PSPIMAGE', 'TGA', 'THM', 'TIF', 'TIFF', 'YUV'].indexOf(extension.toUpperCase()) > -1
        ) {
            fileType = 'image';
        } else {
            fileType = 'file';
        }
        //console.log('openFile', fileId, fileType);
        // this.handleToggleSelect();
        this.props.openFile(fileId, fileType, 'get-content');
    };

    renderAttachment(key, name) {
        let style = {
            position: 'relative',
            padding: 5,
            borderColor: '#333',
            backgroundColor: '#EEE',
            borderRadius: '4px',
            marginBottom: '5px',
            boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
            cursor: 'pointer'
        };
        let aux = name.split('.');
        let extension = aux[aux.length - 1];
        let icon = getIconForFileExtension(extension);

        return (
            <div key={key} style={style} onClick={() => this.handleOpenAttachment(key, name)}>
                <img
                    src={icon}
                    alt="file icon"
                    style={{
                        marginRight: '5px',
                        height: '20px',
                        width: 'auto',
                        verticalAlign: 'middle'
                    }}
                />
                <div
                    style={{
                        display: 'inline-block',
                        verticalAlign: 'middle',
                        maxWidth: 'calc(100% - 25px)',
                    }}
                >
                    {name}
                </div>
                <div
                    style={{
                        display: 'inline-block',
                        position: 'absolute',
                        right: 0,
                        verticalAlign: 'middle',
                        top: '50%',
                        transform: 'translate(0,-50%)',
                    }}
                >
                    {this.props.disabled !== true ?
                        (this.state.deleteConfirmationPending && this.state.pendingDeleteId === key) ?
                            <div>
                                <IconButton name={'fa-check'} padding={5} primaryColor="#333" onClick={this.handleAgreeConfirmation} />
                                {'  '}
                                <IconButton name={'fa-close'} padding={5} primaryColor="#333" onClick={this.handleDisagreeConfirmation} />
                            </div>
                            :
                            <IconButton
                                name={'fa-trash'}
                                padding={5}
                                primaryColor="#f00"
                                onClick={evt => this.handleDeleteAttachment(evt, key)}
                            />
                        : ''
                    }
                </div>
            </div>
        );
    }

    onDrop = async droppedFiles => {
        this.setState({ uploadingFiles: true });
        for (let i = 0; i < droppedFiles.length; i++) {
            let currentFile = droppedFiles[i];
            await this.metadocumentApiClient.uploadAttachment(currentFile);
        }
        this.loadNotesAndAttachments();
        this.setState({ uploadingFiles: false });
    };

    handleMeetingEdit = evt => {
        evt.stopPropagation();
        this.props.openContent(
            this.metadocumentApiClient.getData().contentId,
            this.metadocumentApiClient.getData().objectType,
            'edit',
            evt
        );
    };

    renderContent() {
        let dateUpdated = this.metadocumentApiClient.getDateUpdated();
        return (
            <div onClick={evt => evt.stopPropagation()} >
                <div
                    style={{
                        position: 'absolute',
                        top: '20px',
                        right: '20px',
                        cursor: 'pointer'
                    }}
                    data-id="close-mtg-notes"
                >
                    <IconButton
                        name="fa-close"
                        padding={5}
                        size="20px"
                        primaryColor="#000"
                        secondaryColor="#ccc"
                        onClick={this.handleToggleSelect}
                    />
                </div>
                <h1>
                    {this.metadocumentApiClient.getName()}
                    {(this.props.openContent && this.props.disabled !== true) &&
                        // <div style={{ display: 'inline-block' }} data-id="edit-mtg-btn">
                            <IconButton data-id="edit-mtg-btn" name="md-edit" primaryColor="#000" secondaryColor="#ccc" onClick={this.handleMeetingEdit} />
                        // </div>
                    }
                </h1>
                <h4>
                    {`${LocalizedStrings.mtgDate}: `}
                    <br />
                    <DateTimePicker
                        label={''}
                        selected={this.state.mtgDate}
                        onChange={this.handleDateChange}
                        showTimeSelect
                        timeFormat="HH:mm"
                        timeIntervals={15}
                        dateFormat="LLL"
                        timeCaption="time"
                        disabled={this.props.disabled}
                    />
                </h4>
                <h4>{dateUpdated && `${LocalizedStrings.lastUpdated}: ` + dateUpdated.toLocaleString()}</h4>
                <h4>{`${LocalizedStrings.notes}: `}</h4>
                <div
                    style={{
                        width: 'calc(100% - 24px)',
                        maxHeight: '35vh',
                        overflow: 'auto',
                        border: '1px solid #999999',
                        padding: 10,
                        marginBottom: 20,
                        borderRadius: '10px'
                    }}
                >
                    {this.props.disabled === true ?
                        <span>{this.state.notes ? this.state.notes : LocalizedStrings.notes}</span>
                        :
                        <RichText slot="text" placeholder={LocalizedStrings.notes} content={this.state.notes} onChange={this.handleEditorChange} />
                    }
                </div>
                <h4>{`${LocalizedStrings.attachments}: `}</h4>
                <Dropzone
                    onDrop={this.onDrop}
                    disabled={this.props.disabled}
                    style={{
                        padding: 20,
                        border: '1px dashed #999999',
                        backgroundColor: '#FFF',
                        borderRadius: '10px',
                        display: 'inline-block',
                        width: 'calc(40% - 42px)',
                        height: '200px',
                        position: 'relative',
                        verticalAlign: 'top',
                        color: '#ccc',
                        textAlign: 'center'
                    }}
                >
                    {this.state.uploadingFiles ?
                        <Loader loading={true} size={'30px'} />
                        :
                        <p>{LocalizedStrings.tryDrop}</p>
                    }
                </Dropzone>
                <div
                    style={{
                        display: 'inline-block',
                        width: 'calc(60% - 45px)',
                        verticalAlign: 'top',
                        marginLeft: '5px',
                        paddingLeft: '40px'
                    }}
                >
                    {Object.keys(this.state.attachments).map(attachmentKey => {
                        let attachment = this.state.attachments[attachmentKey];
                        // console.log('attachments', this.state.attachments)
                        return this.renderAttachment(attachmentKey, attachment.filename);
                    })}
                </div>
            </div>
        );
    }

    handleToggleSelect = evt => {
        if (evt) {
            evt.stopPropagation();
        }
        this.setState({ isMeetingsOpen: !this.state.isMeetingsOpen });
    };

    render() {
        const { fullScreen } = this.props;
        return (
            <div style={{ display: 'inline-block' }}>
                <div data-id="mtg-notes-btn" style={{ display: 'inline-block' }} onClick={this.handleToggleSelect}>
                    {this.props.children}
                </div>
                <Dialog
                    fullScreen={fullScreen}
                    open={this.state.isMeetingsOpen}
                    onClose={this.handleToggleSelect}
                    aria-labelledby="responsive-dialog-title"
                >
                    <DialogContent>
                        {this.renderContent()}
                    </DialogContent>
                </Dialog>
            </div>
        );
    }
}
export default withMobileDialog()(MeetingNotes);
